// src/header/MobileProfileMenu.jsx

import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog, faQuestionCircle, faSignOutAlt, faCrown, faUser,  } from '@fortawesome/free-solid-svg-icons';
import { faWebAwesome } from '@fortawesome/free-brands-svg-icons';

import { useAuth } from '../AuthContext'; // ✅ Contextul de autentificare
import './MobileProfileMenu.css';

const apiUrl = process.env.REACT_APP_API_URL;

export const MobileProfileMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const menuRef = useRef(null);
  const toggleRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  const { user, setUser } = useAuth();      // ✅ Obține userul și funcția de setare
  const isAuthenticated = !!user;           // ✅ Verifică dacă e logat

  // ✅ Închide meniul la schimbare de pagină
  useEffect(() => {
    setMenuOpen(false);
  }, [location]);

  // ✅ Închide meniul dacă se dă click în afară
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (
        menuRef.current &&
        !menuRef.current.contains(e.target) &&
        !toggleRef.current.contains(e.target)
      ) {
        setMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  // ✅ Logout
const handleLogout = async () => {
  try {
    await fetch(`${apiUrl}/logout`, {
      method: 'POST',
      credentials: 'include',
    });

    localStorage.removeItem('manuallyLoggedOut'); // ✅ curățăm flag-ul
    setUser(null);           
    navigate('/');           // ✅ redirect mereu spre Home
  } catch (err) {
    console.warn('Logout failed:', err);
  }
};


  if (!isAuthenticated) return null;

  return (
    <div className="mpmenu-wrapper">
      {/* Toggle button */}
      <div ref={toggleRef} className="mpmenu-toggle" onClick={() => setMenuOpen(!menuOpen)}>
        {menuOpen ? (
          <>
            <div className="mpmenu-dot-log" />
            <div className="mpmenu-dot-log" />
            <div className="mpmenu-dot-log" />
          </>
        ) : (
          <>
            <div className="mpmenu-line-log" />
            <div className="mpmenu-line-log" />
            <div className="mpmenu-line-log" />
          </>
        )}
      </div>

      {/* Dropdown menu */}
      <div ref={menuRef} className={menuOpen ? 'mpmenu-visible' : 'mpmenu-hidden'}>
        <div className="mpmenu-header">
          <button className="mpmenu-close" onClick={() => setMenuOpen(false)}>×</button>
        </div>
        <div className="dimension-menu-profile">
         
          <div className="mpmenu-link" onClick={() => navigate('/settings')}>
            <FontAwesomeIcon icon={faCog} /> Setări
          </div>
          <div className="mpmenu-link" onClick={() => navigate('/viewplans')}>
            <FontAwesomeIcon icon={faCrown} /> Premium
          </div>
          

          <div className="mpmenu-link" onClick={() => navigate('/ajutor')}>
            <FontAwesomeIcon icon={faQuestionCircle} /> Ajutor
          </div>
          <div className="mpmenu-link" onClick={handleLogout}>
            <FontAwesomeIcon icon={faSignOutAlt} /> Logout
          </div>
        </div>
      </div>
    </div>
  );
};
